import { FC, ReactElement } from "react";
import Title from "../ui/Title";
import { selectActiveTab, setActiveTab } from "../../store/reducers/uiReducer";
import { useAppDispatch, useAppSelector } from "../../hooks";
import PrismicTranslation from "../PrismicTranslation";
import ChevronDownIcon from "../ui/Icons/ChevronDownIcon";
import ChevronUpIcon from "../ui/Icons/ChevronUpIcon";

interface ConfiguratorSelectorProps {
  title?: string;
  tabKey: string;
  hasOptions: boolean;
  selected?: string;
  children: ReactElement;
  onClick?: (isOpen: boolean) => void;
}

export const ConfiguratorSelector: FC<ConfiguratorSelectorProps> = ({
  title,
  tabKey,
  hasOptions,
  selected,
  children,
  onClick,
}) => {
  const dispatch = useAppDispatch();
  const activeTab = useAppSelector(selectActiveTab);
  const isAlreadyOpen = activeTab === tabKey;

  const handleClick = () => {
    onClick && onClick(!isAlreadyOpen);
    dispatch(setActiveTab(isAlreadyOpen ? "" : tabKey));
  };

  const shouldShow = tabKey && activeTab === tabKey && hasOptions;

  return (
    <div className="items-flex-start flex flex-col gap-2 p-3 relative border-b border-neutrals-300">
      <div className="head">
        <div className="relative">
          <div onClick={handleClick} className="mb-2 cursor-pointer">
            {title && <Title label={title} />}
            <p className="text-text text-xs">
              {!!selected ? (
                <span dangerouslySetInnerHTML={{ __html: selected }} />
              ) : (
                <PrismicTranslation field={"no_selection"} simple />
              )}
            </p>
            {hasOptions && (
              <>
                {!shouldShow ? (
                  <ChevronDownIcon className="absolute right-0 top-2 fill-primary-300" />
                ) : (
                  <ChevronUpIcon className="absolute right-0 top-2 fill-primary-300" />
                )}
              </>
            )}
          </div>
        </div>
      </div>
      {shouldShow && <>{children}</>}
    </div>
  );
};
